function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import MenuContentComponent from "./menu-content/menu-content-component";
import { StyledOutlineButtonWithMenuComponent } from "./menu-component.scss";
class OutlineButtonWithMenuComponent extends PureComponent {
    showMenu() {
        this.setState({
            showMenu: true
        });
    }
    hideMenu() {
        this.setState({
            showMenu: false
        });
    }
    render() {
        const { buttonLink, menu, className, buttonRenderer } = this.props;
        return /*#__PURE__*/ _jsxs(StyledOutlineButtonWithMenuComponent, {
            className: `menu-component ${className}`,
            onMouseEnter: this.showMenu,
            onMouseLeave: this.hideMenu,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "button-wrapper",
                    children: buttonRenderer && buttonRenderer()
                }),
                this.state.showMenu && /*#__PURE__*/ _jsx("div", {
                    className: "menu-content-wrapper",
                    style: menu.style,
                    children: /*#__PURE__*/ _jsx(MenuContentComponent, _object_spread({}, menu))
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            showMenu: false
        };
        this.showMenu = this.showMenu.bind(this);
        this.hideMenu = this.hideMenu.bind(this);
    }
}
export { OutlineButtonWithMenuComponent as default };
OutlineButtonWithMenuComponent.defaultProps = {
    menu: {},
    buttonLink: {}
};
